<section class="pt-0 pb-0">
  <ngx-spinner></ngx-spinner>
<!-- **************************** -->
<!-- main banner css -->
<!-- **************************** -->
<div id="demo" class="carousel slide hero-slider casestudy-banner mt-110" data-ride="carousel">
  <div class="container">
    <div class="bg-slider min-h-400">
    <div class="carousel-inner">
      <ngx-slick class="carousel" #slickModal="slick-modal" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let data of sliderData" class="slide" (click)="itemClickOnNgxClick(data)">
          <img [src]="imageBasePath + data.image" alt="first slide" style="display: block; width: 100%;">
          <div class="carousel-caption d-none d-md-block text-left">
              <h3 id="scrollingToTop">{{data?.title}}</h3>
              <!-- <p><strong><span class="roboto-light">By<strong>:</strong></span> {{data?.author}}</strong></p> -->
            </div>
        </div>
    </ngx-slick>
  </div>
        <!-- <carousel [noPause]="false" [isAnimated]="true" [interval]="cycleInterval">
            <slide *ngFor="let data of sliderData; let i=index">
              <img [src]="imageBasePath + data.image" alt="first slide" style="display: block; width: 100%;">
              <div class="carousel-caption d-none d-md-block text-left">
                  <h3>{{data?.title}}</h3>
                  <p><strong><span class="roboto-light">By<strong>:</strong></span> {{data?.author}}</strong></p>
                </div>
            </slide>
          </carousel> -->

      <!-- <div class="carousel-item active">
        <img src="img/interview/interviewsliderimg1.jpg" alt="">
        <div class="carousel-caption text-left">
          <h3>Educate, empower and equip
            everyone Digitally and Spiritually</h3>
          <p class="mb-0"><strong>How did Galway Foundation begin? Please can you......</strong></p>
          <p><strong><span class="roboto-light">By<strong>:</strong></span> Kavita Srinivasa</strong></p>
        </div>
      </div> -->
    </div>
  </div>
</div>


<!-- **************************** -->
<!-- main banner css end-->
<!-- **************************** -->

<section class="casestudy-no-bg interview-page comman-page pt-0 pb-280" >
  <div class="container">
    <div class="inner-container">
      <h2 class="page-title mb-4">Interviews</h2>

      <div class="row interviews-row initial-interview" *ngFor="let data of interview; let i=index; let isOdd=odd">
        <div class="col-md-6 col-4 intr-left hide-on-init" animateOnScroll animationName="animated fadeIn">
            <div class="wrap">
              <img [src]="imageBasePath + data.images[0]" alt="">
            </div>
          </div>
          <div class="col-md-6 col-8 intr-right hide-on-init" animateOnScroll animationName="animated fadeIn">
            <div class="wrap">
              <!-- <h3>where</h3>
              <h2>Crowdfunding blends</h2>
              <h3>with E-Commerce</h3> -->
              <h2>{{data?.title}}</h2>
              <p class="d-inline-block"><span class="text-grey">With:</span> {{data?.candidate_name}} </p>
              <div class="clearfix"></div>
              <a [routerLink]="['/knowledge-section/interview/detail',data?._id]" class="btn btn-primary pl-3 pr-3 rounded-pill">Read</a>
            </div>
          </div>
      </div>
      <div class="row pagination-row mt-5 mb-0" [hidden]="!showPagination">
        <div class="col-md-12 text-right">
          <div class="pagination justify-content-end">
              <div class="page-item">
                <pagination [boundaryLinks]="true" [itemsPerPage]="itemsPerPage" [totalItems]="totalItems" [(ngModel)]="page" (pageChanged)="pageChanged($event)"
                [customPreviousTemplate]="prevTemplate"
                [maxSize]="maxSize"
            [customNextTemplate]="nextTemplate"
                [ngClass]="(totalPages == page) ? 'my-pagination' : ''"
                [customFirstTemplate]="firstTemplate"
                [customLastTemplate]="lastTemplate"></pagination>
                <ng-template #nextTemplate let-disabled="disabled" let-currentPage="currentPage">
                  <ng-container *ngIf="!disabled">
                    Next
                  </ng-container>
                </ng-template>

                <ng-template #prevTemplate let-disabled="disabled" let-currentPage="currentPage">
                  <ng-container *ngIf="!disabled">
                    Previous
                  </ng-container>
                </ng-template>

              <ng-template #lastTemplate let-disabled="disabled" let-currentPage="currentPage">
                <ng-container *ngIf="!disabled">
                Last
                </ng-container>
              </ng-template>
               
              <ng-template #firstTemplate let-disabled="disabled" let-currentPage="currentPage">
                <ng-container *ngIf="!disabled">
                First
                </ng-container>
              </ng-template>
              </div>
            </div>
        </div>
      </div>

      <div class="row view-btn">
        <div class="col-md-12"><a class="btn btn-default" href=""></a></div>
      </div>


    </div>
  </div>
</section>
</section>
